export default {
    block: {
        display: 'block',
    },
    inlineBlock: {
        display: 'inline-block',
    },
};
